import { useState } from 'react';
import { Stack, Radio, RadioGroup as RG, FormControlLabel, Typography } from '@mui/material';

interface RadioGroupProps {
	options: Array<{ label: string; value: string; subtitle?: string }>;
}

export const useRadioGroup = ({ options }: RadioGroupProps) => {
	const [value, setValue] = useState(options[0].value);

	const RadioGroup = () => (
		<RG value={value} onChange={(e) => setValue(e.target.value)}>
			{options.map((option) => (
				<Stack key={option.value}>
					<FormControlLabel
						key={option.value}
						value={option.value}
						control={<Radio />}
						label={<Typography variant="subtitle1">{option.label}</Typography>}
					/>
					{option.subtitle && (
						<Typography sx={{ ml: 4 }} variant="body2" color="black">
							{option.subtitle}
						</Typography>
					)}
				</Stack>
			))}
		</RG>
	);

	return { RadioGroup, value, setValue };
};
